import { AUTH_BODY } from "../features/auth/authTheme"

export default function Input({
    required,
    label,
    type,
    placeholder,
    value,
    onChange,
    onFocus,
    onBlur,
}: {
    required?: boolean
    label?: string
    type?: string
    placeholder?: string
    value?: string
    onChange: (value: string) => void
    onFocus?: () => void
    onBlur?: () => void
}) {
    const inputId = label?.toLowerCase().replace(/\s+/g, "-") ?? "field"

    return (
        <div className="w-full">
            <label htmlFor={inputId} className="text-[13px] leading-relaxed text-white/55" style={{ fontFamily: AUTH_BODY, fontWeight: 500 }}>
                {label}
                {required && <span className="text-[#e4206b]">&nbsp;*</span>}
            </label>
            <input
                id={inputId}
                className="w-full border-b border-white/15 py-2 text-[16px] leading-snug text-white placeholder:text-white/25 focus:border-[#349be6] focus:outline-none"
                style={{ fontFamily: AUTH_BODY, fontWeight: 500 }}
                name={inputId}
                type={type || "text"}
                placeholder={placeholder}
                value={value}
                onChange={e => onChange(e.target.value)}
                onFocus={onFocus}
                onBlur={onBlur}
            />
        </div>
    )
}
